export default "__VITE_ASSET__Cwur609X__"